var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutopay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12658_34508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40814 10.6297C7.40814 9.65786 6.67178 8.87012 5.70407 8.87012C4.73635 8.87012 4 9.65786 4 10.6297V14.1488H4.42605C4.42605 13.4199 4.99833 12.8292 5.70407 12.8292C6.40981 12.8292 6.98207 13.4201 6.98207 14.1488H7.40814V10.6297Z",
    fill: "#199BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77975 8.57739L8.68555 14.1489H9.65719L9.86855 12.9256H11.0759L11.2873 14.1489H12.2872L11.1928 8.57739H9.77975ZM10.0043 12.1618L10.4721 9.47343L10.94 12.1618H10.0043Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4517 12.8709C14.4517 13.2683 14.2328 13.4632 13.9385 13.4632C13.6441 13.4632 13.5159 13.2918 13.5159 12.9255V10.0735H12.5801V13.0501C12.5801 13.8449 12.9725 14.2189 13.5461 14.2189C14.0139 14.2189 14.3007 13.9773 14.4517 13.6422V14.1486H15.3875V10.0735H14.4517V12.8709Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9434 9.25537H16.879V10.0737H17.5205V10.7828H16.879V13.0112C16.879 13.2917 16.9922 13.4164 17.2337 13.4164C17.3545 13.4164 17.4677 13.4008 17.5205 13.3774V14.1177C17.4451 14.1488 17.264 14.18 17.0527 14.18C16.2754 14.18 15.9434 13.8215 15.9434 13.0891V9.25537Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2916 10.0034C18.4313 10.0034 17.8125 10.5254 17.8125 11.5307V12.7072C17.8125 13.6969 18.4313 14.2189 19.284 14.2189C20.1367 14.2189 20.7857 13.6969 20.7857 12.6917V11.5151C20.7857 10.5176 20.1594 10.0034 19.2916 10.0034ZM19.8425 12.7308C19.8425 13.2294 19.6615 13.4788 19.2916 13.4788C18.9216 13.4788 18.7482 13.2294 18.7482 12.7308V11.4841C18.7482 10.9776 18.9369 10.736 19.2916 10.736C19.6463 10.736 19.8425 10.9776 19.8425 11.4919V12.7308Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1897 10.5723C22.3483 10.2606 22.6577 10.0034 23.1104 10.0034C23.782 10.0034 24.2273 10.4708 24.2273 11.4448V12.7618C24.2273 13.7436 23.7594 14.2189 23.0728 14.2189C22.6349 14.2189 22.3255 13.993 22.1897 13.6813V15.4225H21.2539V10.0737H22.1897V10.5723ZM22.7556 13.4866C23.1028 13.4866 23.284 13.2606 23.284 12.7697V11.4451C23.284 10.9387 23.0876 10.7438 22.7556 10.7438C22.3934 10.7438 22.182 11.001 22.182 11.5075V12.7152C22.182 13.2216 22.3708 13.4866 22.7556 13.4866Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6733 10.5412C26.53 10.2139 26.2659 10.0034 25.8282 10.0034C25.164 10.0034 24.666 10.4787 24.666 11.4683V12.7619C24.666 13.7516 25.1338 14.2191 25.7829 14.2191C26.2356 14.2191 26.5224 13.9619 26.6733 13.6346V14.1488H27.6092V10.0735H26.6733V10.5412ZM26.6809 12.7074C26.6809 13.2138 26.4695 13.4788 26.1073 13.4788C25.7903 13.4788 25.6093 13.2761 25.6093 12.7775V11.4528C25.6093 10.9463 25.7903 10.7281 26.1301 10.7281C26.4923 10.7281 26.6811 10.9931 26.6811 11.5151L26.6809 12.7074Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4861 12.5514L30.0822 10.0735H30.9991L29.4831 15.4224H28.5442L29.0108 13.8217L27.8711 10.0735H28.8672L29.4861 12.5514Z",
    fill: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12658_34508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 6.84507,
    fill: "white",
    transform: "translate(4 8.57739)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopay);
export default __webpack_public_path__ + "static/media/autopay.ff3d09c2b6c9aa27850209771fb986e8.svg";
export { ForwardRef as ReactComponent };